// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg width=\"60\" height=\"60\" xmlns=\"http://www.w3.org/2000/svg\"><rect width=\"60\" height=\"60\" fill=\"none\"/><circle cx=\"30\" cy=\"30\" r=\"1\" fill=\"rgba%28255,255,255,0.05%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== FOOTER STYLES ===== */
.site-footer {
  background: linear-gradient(180deg, #050505 0%, #000000 100%);
  color: #a3a3a3;
  margin-top: auto;
  position: relative;
  overflow: hidden;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

/* Subtle background pattern */
.site-footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  opacity: 0.4;
  pointer-events: none;
}

/* Main Footer Content */
.footer-main {
  position: relative;
  z-index: 2;
  padding: 5rem 0 4rem 0;
}

.footer-grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.5fr;
  gap: 3rem;
  max-width: 1400px;
  margin: 0 auto;
}

/* Brand Section */
.footer-brand {
  max-width: 400px;
}

.footer-logo {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.footer-logo h3 {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: #fff;
  margin: 0;
}

.footer-logo-subtitle {
  font-size: 0.875rem;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.6);
  letter-spacing: 0.05em;
}

.footer-description {
  font-size: 0.9375rem;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 2rem;
}

.footer-social-links {
  display: flex;
  gap: 1rem;
}

.footer-social-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: all 0.3s ease;
}

.footer-social-btn:hover {
  background: rgba(79, 70, 229, 0.2);
  border-color: rgba(79, 70, 229, 0.5);
  color: #fff;
  transform: translateY(-2px);
}

/* Footer Sections */
.footer-section {
  display: flex;
  flex-direction: column;
}

.footer-section-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #fff;
  margin-bottom: 1.5rem;
  letter-spacing: 0.025em;
}

.footer-nav {
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
}

.footer-link {
  font-size: 0.9375rem;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
  width: fit-content;
}

.footer-link:hover {
  color: #fff;
  padding-left: 0.5rem;
}

/* Contact List */
.footer-contact-list {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.footer-contact-item-inline {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
}

.footer-icon {
  flex-shrink: 0;
  margin-top: 0.125rem;
  color: rgba(255, 255, 255, 0.5);
}

.footer-contact-item-inline a,
.footer-contact-item-inline span {
  font-size: 0.9375rem;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-contact-item-inline a:hover {
  color: #fff;
}

.footer-phone-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.footer-phone-group a {
  display: block;
}

/* Footer Bottom */
.footer-bottom {
  position: relative;
  z-index: 2;
  /* background: rgba(0, 0, 0, 0.4); */
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  padding: 1.5rem 0;
}

.footer-bottom-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.5rem;
  max-width: 1400px;
  margin: 0 auto;
}

.footer-copyright p {
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}

.footer-legal {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.footer-legal-link {
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-legal-link:hover {
  color: rgba(255, 255, 255, 0.9);
}

.footer-social {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.footer-social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 50%;
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-social-link:hover {
  background: rgba(79, 70, 229, 0.2);
  color: #ffffff;
  border-color: rgba(79, 70, 229, 0.5);
  transform: translateY(-2px);
}

/* Responsive Design */
@media (max-width: 1200px) {
  .footer-grid {
    grid-template-columns: 2fr 1fr 1fr 1.5fr;
    gap: 2.5rem;
  }
}

@media (max-width: 1024px) {
  .footer-grid {
    grid-template-columns: 1fr 1fr;
    gap: 3rem;
  }

  .footer-brand {
    grid-column: 1 / -1;
    max-width: 600px;
  }
}

@media (max-width: 768px) {
  /* Hide non-essential content on mobile */
  .footer-mobile-hide {
    display: none !important;
  }

  .footer-main {
    padding: 2rem 0 1.5rem 0;
  }

  .footer-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .footer-brand {
    text-align: center;
    max-width: 100%;
    margin-bottom: 0;
  }

  .footer-logo {
    justify-content: center;
    margin-bottom: 1rem;
  }

  .footer-description {
    text-align: center;
  }

  .footer-social-links {
    justify-content: center;
    gap: 0.75rem;
  }

  .footer-social-btn {
    width: 40px;
    height: 40px;
  }

  .footer-section {
    text-align: center;
  }

  .footer-section-title {
    margin-bottom: 1rem;
    font-size: 1.0625rem;
  }

  .footer-nav {
    align-items: center;
    gap: 0.625rem;
  }

  .footer-link:hover {
    padding-left: 0;
  }

  .footer-contact-list {
    align-items: center;
  }

  .footer-contact-item-inline {
    justify-content: center;
  }

  .footer-bottom-content {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .footer-legal {
    flex-wrap: wrap;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .footer-main {
    padding: 1.5rem 0 1rem 0;
  }

  .footer-grid {
    gap: 1.5rem;
  }

  .footer-logo h3 {
    font-size: 1.75rem;
  }

  .footer-description {
    font-size: 0.875rem;
  }

  .footer-section-title {
    font-size: 1rem;
  }

  .footer-link,
  .footer-contact-item-inline a,
  .footer-contact-item-inline span {
    font-size: 0.875rem;
  }

  .footer-legal {
    flex-direction: column;
    gap: 0.75rem;
  }

  .footer-bottom {
    padding: 1rem 0;
  }

  .footer-contact-list {
    gap: 1rem;
  }

  .footer-social-links {
    gap: 0.5rem;
  }

  .footer-social-btn {
    width: 36px;
    height: 36px;
  }
}

/* Performance Optimizations */
.site-footer {
  contain: layout style;
}

.footer-social-btn,
.footer-link {
  will-change: transform;
}`, "",{"version":3,"sources":["webpack://./src/styles/footer.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAAkN;EAClN,YAAY;EACZ,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,WAAW;EACX,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;;EAEE,oBAAoB;EACpB,+BAA+B;EAC/B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,UAAU;EACV,oCAAoC;EACpC,2BAA2B;EAC3B,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;IACE,wCAAwC;IACxC,WAAW;EACb;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA;EACE,yCAAyC;EACzC;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;AACvB;;AAEA;;EAEE,sBAAsB;AACxB","sourcesContent":["/* ===== FOOTER STYLES ===== */\n.site-footer {\n  background: linear-gradient(180deg, #050505 0%, #000000 100%);\n  color: #a3a3a3;\n  margin-top: auto;\n  position: relative;\n  overflow: hidden;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n/* Subtle background pattern */\n.site-footer::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url('data:image/svg+xml,<svg width=\"60\" height=\"60\" xmlns=\"http://www.w3.org/2000/svg\"><rect width=\"60\" height=\"60\" fill=\"none\"/><circle cx=\"30\" cy=\"30\" r=\"1\" fill=\"rgba(255,255,255,0.05)\"/></svg>');\n  opacity: 0.4;\n  pointer-events: none;\n}\n\n/* Main Footer Content */\n.footer-main {\n  position: relative;\n  z-index: 2;\n  padding: 5rem 0 4rem 0;\n}\n\n.footer-grid {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr 1.5fr;\n  gap: 3rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n/* Brand Section */\n.footer-brand {\n  max-width: 400px;\n}\n\n.footer-logo {\n  display: flex;\n  align-items: baseline;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.footer-logo h3 {\n  font-size: 2rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  color: #fff;\n  margin: 0;\n}\n\n.footer-logo-subtitle {\n  font-size: 0.875rem;\n  font-weight: 300;\n  color: rgba(255, 255, 255, 0.6);\n  letter-spacing: 0.05em;\n}\n\n.footer-description {\n  font-size: 0.9375rem;\n  line-height: 1.7;\n  color: rgba(255, 255, 255, 0.7);\n  margin-bottom: 2rem;\n}\n\n.footer-social-links {\n  display: flex;\n  gap: 1rem;\n}\n\n.footer-social-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  color: rgba(255, 255, 255, 0.7);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.footer-social-btn:hover {\n  background: rgba(79, 70, 229, 0.2);\n  border-color: rgba(79, 70, 229, 0.5);\n  color: #fff;\n  transform: translateY(-2px);\n}\n\n/* Footer Sections */\n.footer-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.footer-section-title {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #fff;\n  margin-bottom: 1.5rem;\n  letter-spacing: 0.025em;\n}\n\n.footer-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 0.875rem;\n}\n\n.footer-link {\n  font-size: 0.9375rem;\n  color: rgba(255, 255, 255, 0.7);\n  text-decoration: none;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  width: fit-content;\n}\n\n.footer-link:hover {\n  color: #fff;\n  padding-left: 0.5rem;\n}\n\n/* Contact List */\n.footer-contact-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.footer-contact-item-inline {\n  display: flex;\n  gap: 0.75rem;\n  align-items: flex-start;\n}\n\n.footer-icon {\n  flex-shrink: 0;\n  margin-top: 0.125rem;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.footer-contact-item-inline a,\n.footer-contact-item-inline span {\n  font-size: 0.9375rem;\n  color: rgba(255, 255, 255, 0.7);\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.footer-contact-item-inline a:hover {\n  color: #fff;\n}\n\n.footer-phone-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.footer-phone-group a {\n  display: block;\n}\n\n/* Footer Bottom */\n.footer-bottom {\n  position: relative;\n  z-index: 2;\n  /* background: rgba(0, 0, 0, 0.4); */\n  backdrop-filter: blur(10px);\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  padding: 1.5rem 0;\n}\n\n.footer-bottom-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.footer-copyright p {\n  font-size: 0.875rem;\n  color: rgba(255, 255, 255, 0.6);\n  margin: 0;\n}\n\n.footer-legal {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.footer-legal-link {\n  font-size: 0.875rem;\n  color: rgba(255, 255, 255, 0.6);\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.footer-legal-link:hover {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.footer-social {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.footer-social-link {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 50%;\n  color: rgba(255, 255, 255, 0.6);\n  text-decoration: none;\n  transition: all 0.3s ease;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.footer-social-link:hover {\n  background: rgba(79, 70, 229, 0.2);\n  color: #ffffff;\n  border-color: rgba(79, 70, 229, 0.5);\n  transform: translateY(-2px);\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .footer-grid {\n    grid-template-columns: 2fr 1fr 1fr 1.5fr;\n    gap: 2.5rem;\n  }\n}\n\n@media (max-width: 1024px) {\n  .footer-grid {\n    grid-template-columns: 1fr 1fr;\n    gap: 3rem;\n  }\n\n  .footer-brand {\n    grid-column: 1 / -1;\n    max-width: 600px;\n  }\n}\n\n@media (max-width: 768px) {\n  /* Hide non-essential content on mobile */\n  .footer-mobile-hide {\n    display: none !important;\n  }\n\n  .footer-main {\n    padding: 2rem 0 1.5rem 0;\n  }\n\n  .footer-grid {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n\n  .footer-brand {\n    text-align: center;\n    max-width: 100%;\n    margin-bottom: 0;\n  }\n\n  .footer-logo {\n    justify-content: center;\n    margin-bottom: 1rem;\n  }\n\n  .footer-description {\n    text-align: center;\n  }\n\n  .footer-social-links {\n    justify-content: center;\n    gap: 0.75rem;\n  }\n\n  .footer-social-btn {\n    width: 40px;\n    height: 40px;\n  }\n\n  .footer-section {\n    text-align: center;\n  }\n\n  .footer-section-title {\n    margin-bottom: 1rem;\n    font-size: 1.0625rem;\n  }\n\n  .footer-nav {\n    align-items: center;\n    gap: 0.625rem;\n  }\n\n  .footer-link:hover {\n    padding-left: 0;\n  }\n\n  .footer-contact-list {\n    align-items: center;\n  }\n\n  .footer-contact-item-inline {\n    justify-content: center;\n  }\n\n  .footer-bottom-content {\n    flex-direction: column;\n    text-align: center;\n    gap: 1rem;\n  }\n\n  .footer-legal {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .footer-main {\n    padding: 1.5rem 0 1rem 0;\n  }\n\n  .footer-grid {\n    gap: 1.5rem;\n  }\n\n  .footer-logo h3 {\n    font-size: 1.75rem;\n  }\n\n  .footer-description {\n    font-size: 0.875rem;\n  }\n\n  .footer-section-title {\n    font-size: 1rem;\n  }\n\n  .footer-link,\n  .footer-contact-item-inline a,\n  .footer-contact-item-inline span {\n    font-size: 0.875rem;\n  }\n\n  .footer-legal {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .footer-bottom {\n    padding: 1rem 0;\n  }\n\n  .footer-contact-list {\n    gap: 1rem;\n  }\n\n  .footer-social-links {\n    gap: 0.5rem;\n  }\n\n  .footer-social-btn {\n    width: 36px;\n    height: 36px;\n  }\n}\n\n/* Performance Optimizations */\n.site-footer {\n  contain: layout style;\n}\n\n.footer-social-btn,\n.footer-link {\n  will-change: transform;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
